import { Tab } from "../../../Reusablecomponents/Tab";
import styled from "styled-components";
import { Card, Col, Dropdown, Row } from "antd";
import { ReactComponent as PrimaryExportIcon } from "../../../assets/images/PrimaryActive (2).svg";
import React, { useEffect, useRef, useState, useMemo } from "react";
import upload from "../../../assets/images/upload.svg";
import filtericon from "../../../assets/images/Filter-Icon.svg";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import {
  TripTypeEnum,
  TripStatusEnum,
  TripStatusForCustom,
} from "../../../Common/constant";
import {
  Badge,
  Avatar,
  Form,
  Select,
  Button,
  Modal,
  DatePicker,
  Spin,
  message,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import {
  PieChart,
  Pie,
  Legend,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
} from "recharts";
import { CALL_API } from "../../../Common/api";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import { ButtonOutlined } from "../../../Reusablecomponents/UIButtons";

const Customstyle = styled.div`
  .recharts-surface {
    height: 90% !important;
  }
  .Wrappertitle {
    font-size: 16px;
    font-weight: 400;
    color: #5f6d8c;
  }
  .ant-avatar > img {
    display: block;
    width: 60%;
    height: 60%;
    object-fit: cover;
  }
  .head {
    text-align: center;
  }
  .Wrapper_div {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 15px 20px 15px 20px;
  }
  /* Card styling - white background and gray border */
  .card-item {
    background-color: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    flex: 1;
    max-width: 49%;
    height: 390px;
    box-sizing: border-box;
  }

  /* Ant Design Card border override */
  .ant-card {
    background-color: #ffffff;
    border: 1px solid #d9d9d9;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @media screen and (min-width: 320px) and (max-width: 426px) {
    .recharts-wrapper {
      width: 500px !important;
      height: 350px !important;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 425px) {
    .tripStatusChart {
      width: 80px !important;
      height: 180px !important;
      margin: 0 auto;
    }

    .tripStatusChart svg {
      width: 80px !important;
      height: 90px !important;
    }
  }

  .ant-card-bordered.Card_for_containerone {
    border: none !important;
  }

  .Card_for_containerone.ant-card .ant-card-body {
    padding: 6px !important;
  }

  .Card_for_containerone {
    margin-top: 30px !important;
  }

  .title_onE {
    font-size: 16px;
    font-weight: 400;
    color: #5f6d8c;
  }

  .title_new_column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px;
  }

  .title {
    font-size: 16px;
    font-weight: 400;
    color: #5f6d8c;
  }

  .carddiv {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .cardtitle {
    font-weight: 500;
    font-size: 16px;
  }

  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .Custom {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  /* Badge styling */
  .badg {
    position: relative;
    display: inline-block;
  }

  .badg .ant-badge-count {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 16px;
    height: 16px;
    font-size: 12px;
    line-height: 16px;
    padding: 0 4px;
    background-color: #ff4d4f;
    border-radius: 8px;
    color: #fff;
    font-weight: 500;
  }

  .filterstyle {
    cursor: pointer;
    transition: all 0.3s;
  }

  .filterstyle:hover {
    opacity: 0.8;
  }

  .ab {
    display: inline-block;
    width: 4px !important;
    height: 4px !important;
    background-color: #e4a400;
    border-radius: 50%;
    margin-right: 4px;
    margin-bottom: 1px !important;
  }

  .titlestyle {
    text-align: center;
  }

  .status-container {
    display: flex;
    align-items: center;
  }

  .status-circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .completed {
    background-color: #00bc13;
  }

  .incomplete {
    background-color: blue;
  }

  .in-progress {
    background-color: #007eea;
  }

  .unassigned {
    background-color: red;
  }

  .unknown {
    background-color: gray;
  }

  .down-arrow {
    margin-left: 8px;
    font-size: 14px;
    color: green;
  }

  @media screen and (max-width: 768px) {
    .card-item {
      max-width: 100%;
    }

    .bottom-action-bar {
      position: fixed;
      bottom: 0;
      background-color: white;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: right;
      gap: 16px;
      padding: 12px 0;
      z-index: 10;
      width: 100%;
    }
  }

  .ant-table-tbody > tr:nth-child(odd) {
    background-color: rgb(237, 255, 241);
  }
`;

const { Option } = Select;

const CustomDashboardContainer = styled.div`
  .dropdowncontainer.ant-card .ant-card-body {
    padding: 07px 07px 07px 07px !important;
  }
  @media screen and (min-width: 426px) and (max-width: 768px) {
    div[tabindex="0"] {
      width: 100% !important;
      height: auto !important;
      overflow-y: auto;
    }
  }

  .ant-tabs-tab {
    background-color: white !important;
    border-radius: 25px;
    font-size: 16px !important;
    font-weight: 500 !important;
    padding: 10px 40px 10px 40px !important;
    color: #5f6d8c !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    background-color: green !important;
  }
  .ant-tabs-tab-active {
    background-color: white !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    padding: 10px 40px 10px 40px !important;
  }
  .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: white !important;
  }
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #5f6d8c;
    line-height: 0px;
  }
  .carddiv_one {
    /* display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3px 6px; */
  }
`;

export const CustomDashboardAI = () => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [Handledropdownselect, SetHandledropdownselect] =
    useState("Trackright AI+");
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("CUSTDASH", "EX"),
    [reduxPermissions],
  );

    const exportAIAllowed = useMemo(
    () => hasPermission("AICUSTDASH", "EX"),
    [reduxPermissions],
  );
    const custRead = useMemo(
    () => hasPermission("CUSTDASH", "R"),
    [reduxPermissions],
  );
  const custAIRead = useMemo(
    () => hasPermission("AICUSTDASH", "R"),
    [reduxPermissions],
  );
  const items = [
    userInfo?.MCID !== 71 && subscriptionList.includes("CUSTDASH") && custRead && {
      key: "TrackRight AI+",
      label: "TrackRight AI+",
      children: (
        <>
          {" "}
          <TrackrightAIPlus exportAllowed={exportAllowed} />
        </>
      ),
    },
    subscriptionList.includes("AICUSTDASH") && custAIRead && {
      key: "TrackRight AI",
      label: "TrackRight AI",
      children: (
        <>
          <TrackrightAI exportAllowed={exportAIAllowed} />
        </>
      ),
    },
  ].filter(Boolean);

  const menuItems = [
    {
      key: "label1",
      label: (
        <span onClick={() => handleTabChange("TrackrightAIPlus")}>
          Trackright AI+
        </span>
      ),
    },
    {
      key: "label2",
      label: (
        <span onClick={() => handleTabChange("TrackrightAI")}>
          Trackright AI
        </span>
      ),
    },
  ];

  const handleTabChange = (event) => {
    SetHandledropdownselect(event);
  };

  const componentsMap = {
    TrackrightAIPlus: <TrackrightAIPlus exportAllowed={exportAllowed}/>,
    TrackrightAI: <TrackrightAI exportAllowed={exportAIAllowed}/>,
  };

  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= 320 && window.innerWidth <= 426,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= 320 && window.innerWidth <= 426);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <CustomDashboardContainer>
        <div className="CustomDashboardContainer">
          {isMobile ? (
            <>
              <Card className="dropdowncontainer">
                <Dropdown
                  menu={{ items: menuItems }}
                  trigger={["click"]}
                  placement="bottom"
                >
                  <ButtonOutlined
                    className="border-0 text-success"
                    style={{
                      borderRadius: "40px",
                      backgroundColor: "#E8FFEC",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>{Handledropdownselect}</span>
                    <DownOutlined
                      style={{ color: "#2C963D", marginLeft: "8px" }}
                    />
                  </ButtonOutlined>
                </Dropdown>
              </Card>
              <div style={{ marginTop: "20px" }}>
                {componentsMap[Handledropdownselect]}
              </div>
            </>
          ) : (
            <div className="custom_dashboard_ai">
              <Tab
                className="custom_dashboard_ai_tab"
                items={items}
                defaultActiveKey="TrackRight AI+"
              />
            </div>
          )}
        </div>
      </CustomDashboardContainer>
    </>
  );
};
export const TrackrightAIPlus = ({ exportAllowed }) => {
  const csvLinkEl = useRef();
  // const COLORS = ["#00BC13", "#007EEA"];
  // const COLORS = ["#007EEA", "#00BC13"];
  const COLORS = ["#007EEA", "#00BC13"]; // Blue, Green
  const barcolor = ["#9FE4FF", "#7BFF88"];
  const [tripStatus, setTripStatus] = useState([]);
  const [tripStatusLoading, setTripStatusLoading] = useState(false);
  const [tripStatusChart, setTripStatusChart] = useState([]);
  const [vehicleUtilization, setVehicleUtilization] = useState([]);
  const [tripStatusChartLoading, setTripStatusChartLoading] = useState(false);
  const [vehicleUtilizationLoading, setVehicleUtilizationLoading] =
    useState(false);
  const [Customdata, setCustomdata] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const [tableLoading, setTableLoading] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const vehicleListone = useSelector(
    (state) => state?.authTracking?.vehicleList,
  );

  //FILTER
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({});

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  const getFilterCount = () => {
    const values = form.getFieldsValue();
    const count = Object.values(values).filter(
      (val) => val !== undefined && val !== null && val !== "",
    ).length;
    setFilterCount(count);
  };

  //Pagination
  const [customPageSize, setCustomPageSize] = useState(10);
  const [customCurrentPage, setCustomCurrentPage] = useState(1);
  const [customTotal, setCustomTotal] = useState(0);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);

  const [expandedIndexes, setExpandedIndexes] = useState({});
  const toggleExpand = (key) => {
    setExpandedIndexes((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleCustomPageChange = (page, pageSize) => {
    setCustomCurrentPage(page);
    setCustomPageSize(pageSize);
    getCustomTableData(page, pageSize);
  };

  const handleCustomPageSizeChange = (size) => {
    setCustomPageSize(size);
    setCustomCurrentPage(1);
    getCustomTableData(1, size);
  };

  const getTripStatus = async () => {
    try {
      setTripStatusLoading(true);
      const { data } = await CALL_API("POST", "customeDashboard");
      setTripStatus(data);
      setTripStatusLoading(false);
    } catch (error) {
      console.error("[getTripStatus] error -->", error);
    }
  };

  useEffect(() => {
    getTripStatus();
  }, []);

  const BarCustomizedLabel = ({ x, y, width, height, value, index }) => {
    const labelX = x + width / 2;
    const labelY = y - 10; // Put label above the bar
    const lineMidX = labelX + 80; // Shorter horizontal connector
    const lineEndX = lineMidX + 40;
    const lineEndY = labelY - 40;
    const utilizedPercent = vehicleUtilization[0]
      ? Math.round(
          (vehicleUtilization[0].Utilized / vehicleUtilization[0].Active) * 100,
        )
      : 0;
    return (
      <>
        {/* Horizontal line from the bar to the mid point */}
        <line
          x1={labelX}
          y1={labelY + 10}
          x2={lineMidX}
          y2={labelY + 10}
          stroke="#aaa"
          strokeWidth={1.5}
        />

        {/* Diagonal line from the mid point to the box */}
        <line
          x1={lineMidX}
          y1={labelY + 10}
          x2={lineEndX}
          y2={lineEndY}
          stroke="#aaa"
          strokeWidth={1.5}
        />

        {/* Green box (legend color block) */}
        <rect
          x={lineEndX - 35}
          y={lineEndY - 25}
          width={16}
          height={16}
          rx={3}
          fill="#7BFF88"
        />

        <text x={lineEndX - 10} y={lineEndY - 12} fontSize={16} fill="#5F6D8C">
          Utilized {utilizedPercent}%
        </text>
      </>
    );
  };
  const COLOURS = ["#007EEA", "#00BC13"];
  const renderCustomizedLabel = ({
    cx,
    cy,
    innerRadius,
    outerRadius,
    index,
  }) => {
    const squareSize = 16;
    const textOffset = 8;
    const lineLength = 30; // horizontal line length from pie to label
    const verticalSpacing = 32; // space between stacked labels

    // Position all labels at the same X (right of pie)
    const labelX = cx + outerRadius + lineLength + squareSize + textOffset + 10;
    // Stack labels vertically, centered on the pie
    const labelY =
      cy -
      ((tripStatusChart.length - 1) * verticalSpacing) / 2 +
      index * verticalSpacing;

    // Line starts at the right edge of the pie, at the same Y as the label
    const sx = cx + outerRadius;
    const sy = labelY;
    const ex = sx + lineLength;
    const ey = labelY;

    const color = COLORS[index % COLORS.length];

    return (
      <g>
        {/* Connector line */}
        {/* <line x1={sx} y1={sy} x2={ex} y2={ey} stroke="#ccc" strokeWidth={1} /> */}
        {/* Color square */}
        <rect
          x={ex + 10}
          y={ey - squareSize / 2}
          width={squareSize}
          height={squareSize}
          rx={3}
          fill={color}
        />
        {/* Label text */}
        <text
          x={ex + 10 + squareSize + textOffset}
          y={ey}
          fill="#5F6D8C"
          fontSize={15}
          textAnchor="start"
          dominantBaseline="central"
          fontWeight={500}
        >
          {tripStatusChart[index]
            ? `${tripStatusChart[index].name}  ${tripStatusChart[index].value}`
            : ""}
        </text>
      </g>
    );
  };

  const getTripStatusChart = async () => {
    try {
      setTripStatusChartLoading(true);
      const res = await CALL_API("GET", "custom/trip_status");
      const result = res?.data || {};

      let chartData = [
        { name: "Trips in Progress", value: result.inProgress || 0 }, // Blue
        { name: "Trips Delivered", value: result.delivered || 0 }, // Green
      ];
      chartData = chartData.filter((item) => item.value > 0);

      setTripStatusChart(chartData);
      setTripStatusChart(chartData);
    } catch (error) {
      console.error("Error fetching trip status", error);
    } finally {
      setTripStatusChartLoading(false);
    }
  };

  const getVehicleUtilization = async () => {
    try {
      setVehicleUtilizationLoading(true);
      const res = await CALL_API(
        "GET",
        `custom/vehicle_utilized?mcid=${userInfo?.MCID}`,
      );
      const result = res?.data || {};
      const chartData = [
        {
          name: "Active   Utilized",
          Active: result.activeVehicles || 0,
          Utilized: result.usedVehicles || 0,
        },
      ];
      setVehicleUtilization(chartData);
    } catch (error) {
      console.error("Error fetching vehicle utilization", error);
    } finally {
      setVehicleUtilizationLoading(false);
    }
  };
  const getCustomTableData = async (
    page = customCurrentPage,
    perPage = customPageSize,
  ) => {
    setTableLoading(true);
    try {
      const tripTypeString = TripTypeEnum.find(
        (item) => item.value === formValues?.tripType,
      )?.name;

      const payload = {
        Duration: "Desc",
        // Date: selectedDate?.[1]
        //   ? dayjs(selectedDate[1]).format("YYYY-MM-DD")
        //   : dayjs().format("YYYY-MM-DD"),
        Date: formValues?.daterange
          ? dayjs(formValues?.daterange).format("YYYY-MM-DD")
          : "",
        RECNAME: userInfo?.consigneeList,
        Routes: "",
        Invoice: "",
        Package: "",
        TRIPTYPE: tripTypeString,
        VEHID: formValues?.vehicle || 0,
        CUSTCOLS: "",
        Status: formValues?.Status || null,
        mcId: userInfo?.MCID,
        PerPage: perPage,
        CurPage: page,
      };

      const { data } = await CALL_API(
        "POST",
        "custom/getAllCustomDashData",
        payload,
      );
      setCustomdata(data?.data || []);
      setCustomTotal(data?.total || 0); // If backend returns total
    } catch (error) {
      console.error("[getCustomTableData] error -->", error);
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    getCustomTableData();
  }, [formValues?.daterange]);

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const tripTypeString = TripTypeEnum.find(
        (item) => item.value === formValues?.tripType,
      )?.name;

      const payload = {
        Duration: "Desc",
        Date: formValues?.daterange
          ? dayjs(formValues?.daterange).format("YYYY-MM-DD")
          : "",
        RECNAME: userInfo?.consigneeList,
        Routes: "",
        Invoice: "",
        Package: "",
        TRIPTYPE: tripTypeString,
        VEHID: formValues?.vehicle || 0,
        CUSTCOLS: "",
        mcId: userInfo?.MCID || 0,
        PerPage: customTotal,
        CurPage: 1,
      };

      const { data } = await CALL_API(
        "POST",
        "custom/getAllCustomDashData",
        payload,
      );
      setCSVLoader(false);
      if (data?.data?.length > 0) {
        setCSVList(
          data?.data?.map((item) => {
            const tripStatusLabel = TripStatusMap[item.TRIPSTATUS] || "Unknown";

            return {
              Vehicle: item.REGNO || "-",
              Status: tripStatusLabel,
              "Trip Type": item.TRIPTYPE || "-",
              Consignment: item.Consignments || "-",
              "Delivered / Ordered": `${item.Delivered || 0} / ${
                item.Ordered || 0
              }`,
              "Offloaded Consignments (Day)": item.TotalConsignment_DAY || 0,
              "Offloaded Consignments (Month)":
                item.TotalConsignment_MONTH || 0,
              "Total KMs (Month)": item.TotalKM ?? 0,
            };
          }),
        );

        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  useEffect(() => {
    getTripStatusChart();
    getVehicleUtilization();
    getCustomTableData(customCurrentPage, customPageSize);
  }, [formValues, selectedDate, customCurrentPage, customPageSize]);

  const hasTripStatusData = tripStatusChart?.some((item) => item.value > 0);
  const hasVehicleUtilizationData = vehicleUtilization?.some(
    (item) => item.Active > 0 || item.Utilized > 0,
  );
  const TripStatusMap = TripStatusEnum.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
  }, {});

  const CustomColumn = [
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      render: (text, record) => {
        const statusLabel = TripStatusMap[record.TRIPSTATUS];
        return (
          <div>
            <span>{text}</span>
            {statusLabel === "Completed" ? (
              <div
                style={{
                  color: "#E4A400",
                  fontWeight: "400",
                  marginTop: "4px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span className="ab"></span>
                Safari
              </div>
            ) : statusLabel === "In Progress" ? (
              <div>
                <i> Local</i>
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "Color",
      key: "Color",
      render: (value, record) => {
        let label = "Unknown";
        let statusClass = "unknown";

        // Map Color values to labels and styles
        if (value === 1) {
          label = "Completed";
          statusClass = "completed";
        } else if (value === 2) {
          label = "In Progress";
          statusClass = "in-progress";
        } else if (value === 0) {
          label = "Unassigned";
          statusClass = "unassigned";
        }

        return (
          <div className="status-container">
            <span className={`status-circle ${statusClass}`}></span>
            {label}
          </div>
        );
      },
    },
    {
      title: "Consignment",
      dataIndex: "Consignments",
      key: "Consignments",
      render: (text, record, index) => {  // ← add index parameter here
        const input = "Nakuru Customer0 , Nakuru Customer0 , Nakuru Customer0";
        const extractnamestoarray = text
          .split(",")
          .map((item) => item.trim().slice(0, -1))
          .filter((item) => item.trim() !== "");
        const getColor = (value) => {
          const lastChar = text.slice(-1);
          return lastChar === "1" ? "text-success" : "";
        };
        const rowKey = index;

        return (
          <div>
            {/* Always show first item */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <p className={getColor(extractnamestoarray[0])} style={{ margin: 0 }}>
                {extractnamestoarray[0]}
              </p>

              {/* Arrow only if more than 1 item */}
              {extractnamestoarray.length > 1 && (
                <DownOutlined
                  onClick={() => toggleExpand(rowKey)}
                  style={{
                    cursor: "pointer",
                    fontSize: "11px",
                    transform: expandedIndexes[rowKey] ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                    color: "#2C963D", marginLeft: "8px"
                  }}
                />
              )}
            </div>

            {/* Remaining items when expanded */}
            {expandedIndexes[rowKey] &&
              extractnamestoarray.slice(1).map((item, subIndex) => (
                <p className={getColor(item)} key={subIndex} style={{ margin: 0 }}>
                  {item}
                </p>
              ))}
          </div>
        );
      },
    },
    {
      title: "Delivered / Ordered",
      key: "DeliveredOrdered",
      align: "center",
      render: (text, record) => (
        <span>
          {record.Delivered ?? 0}/{record.Ordered ?? 0}
        </span>
      ),
    },
    {
      title: (
        <>
          <div>Offloaded Consignments</div>
          <div className="titlestyle">(Day)</div>
        </>
      ),
      dataIndex: "TotalConsignment_DAY",
      key: "TotalConsignment_DAY",
      align: "center",
      render: (text) => text ?? 0,
    },
    {
      title: (
        <>
          <div>Offloaded Consignments</div>
          <div className="titlestyle">(Month)</div>
        </>
      ),
      dataIndex: "TotalConsignment_MONTH",
      key: "TotalConsignment_MONTH",
      align: "center",
      render: (text) => text ?? 0,
    },
    {
      title: (
        <>
          <div>Total Kms </div>
          <div className="titlestyle">(Month)</div>
        </>
      ),
      dataIndex: "TotalKM",
      key: "TotalKM",
      align: "center",
      render: (text) => text ?? 0,
    },
  ];
  const Customdata1 = [
    {
      key: "1",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "2",
      Vehicle: "KA1234532",
      Status: "In Progress",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "3",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "4",
      Vehicle: "KA1234532",
      Status: "In Progress",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/5",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "5",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    let newvalue = window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Customstyle>
        <div className="Wrapper_div">
          <p className="Wrappertitle">Chart View</p>
          {userInfo?.MCID !== 71 && (
            <Customstyle>
              {window.innerWidth >= 320 && window.innerWidth <= 426 ? null : (
                <>
                  {/* <Card className="Card_for_containerone">
            <div className="title_new_column">
              <p className="title_onE">Chart View</p>
              <PrimaryExportIcon />
            </div>
          </Card> */}
                </>
              )}
              <br />
              {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
                <Row>
                  <Col
                    style={{ marginBottom: "5px" }}
                    lg={12}
                    xl={12}
                    md={24}
                    sm={24}
                    xs={24}
                  >
                    <Card className="">
                      <div id="chart_view" className="title_new_column">
                        <p className="cardtitle">Trip Status</p>
                        <PrimaryExportIcon
                          style={{
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleDownloadChart("Chart View", "Chart View");
                          }}
                        />
                      </div>

                      {tripStatusChartLoading ? (
                        <p>Loading...</p>
                      ) : hasTripStatusData ? (
                        <>
                          <div style={{ overflowX: "auto", width: "100%" }}>
                            <div style={{ minWidth: 600 }} id="Chart View">
                              <ResponsiveContainer width="100%" height={300}>
                                <PieChart>
                                  <Pie
                                    data={tripStatusChart}
                                    cx="40%"
                                    cy="40%"
                                    innerRadius={68}
                                    outerRadius={96}
                                    paddingAngle={-15}
                                    cornerRadius={40}
                                    startAngle={330} // Starts at the top
                                    endAngle={-250}
                                    dataKey="value"
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                  >
                                    {tripStatusChart.map((entry, index) => (
                                      <Cell
                                        key={`cell-${index}`}
                                        fill={COLOURS[index % COLOURS.length]}
                                        stroke={COLOURS[index % COLOURS.length]}
                                      />
                                    ))}
                                  </Pie>
                                  <Tooltip />
                                </PieChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                          {/* <div className="title_new_column">
                <p className="title_onE">Chart Vieww</p>
                <PrimaryExportIcon />
              </div>
<div style={{ overflowX: "auto", width: "100%" }}>
  <div style={{ minWidth: 500 }}> 
    <ResponsiveContainer width={500} height={300}>
      <PieChart>
        <Pie
          data={tripStatusChart}
          cx="50%"
          cy="50%"
          innerRadius={68}
          outerRadius={96}
          paddingAngle={-15}
          cornerRadius={40}
          startAngle={330}
          endAngle={-250}
          dataKey="value"
          labelLine={false}
          label={renderCustomizedLabel}
        >
          {tripStatusChart.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]}
              stroke={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  </div>
</div> */}
                        </>
                      ) : (
                        <div
                          style={{
                            height: 250,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p style={{ color: "#999" }}>No Data Available</p>
                        </div>
                      )}
                    </Card>
                    <Card className="card-item">
                      <div className="title_new_column">
                        <p className="cardtitle">Vehicle Utilization</p>
                        <PrimaryExportIcon
                          style={{
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleDownloadChart(
                              "Vehicle_Utilization",
                              "Vehicle_Utilization",
                            );
                          }}
                        />
                      </div>

                      {vehicleUtilizationLoading ? (
                        <p>Loading...</p>
                      ) : hasVehicleUtilizationData ? (
                        // <ResponsiveContainer width="50%" height={300}>
                        //   <BarChart
                        //     data={vehicleUtilization}
                        //     margin={{
                        //       top: 40,
                        //       right: 30,
                        //       left: 20,
                        //       bottom: 5,
                        //     }}
                        //     barCategoryGap="25%"
                        //     barGap={55}
                        //     barSize={30}
                        //   >
                        //     <CartesianGrid stroke="none" />
                        //     <XAxis dataKey="name" axisLine={false} tickLine={false} />
                        //     {/* <YAxis axisLine={false} tickLine={false} /> */}
                        //     <Tooltip

                        //     />
                        //     <Bar
                        //       dataKey="Active"
                        //       name="Active"
                        //       fill="#9FE4FF"
                        //       radius={[5, 5, 0, 0]}
                        //       label={BarCustomizedLabel}
                        //     ></Bar>
                        //     <Bar
                        //       label={BarCustomizedLabel}
                        //       dataKey="Utilized"
                        //       name="Utilized"
                        //       fill="#7BFF88"
                        //       radius={[5, 5, 0, 0]}
                        //     />
                        //     {vehicleUtilization.map((entry, index) => (
                        //       <Cell
                        //         key={`cell-${index}`}
                        //         fill={COLORS[index % COLORS.length]}
                        //         stroke={COLORS[index % COLORS.length]}
                        //       />
                        //     ))}
                        //   </BarChart>
                        // </ResponsiveContainer>
                        <>
                          <div
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              width: "100%",
                            }}
                          >
                            <div
                              id="Vehicle_Utilization"
                              style={{ minWidth: 600 }}
                            >
                              <ResponsiveContainer width="100%" height={300}>
                                <BarChart
                                  data={vehicleUtilization}
                                  margin={{
                                    top: 40,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                  barCategoryGap="25%"
                                  barGap={40}
                                  barSize={52}
                                >
                                  <CartesianGrid stroke="none" />
                                  <XAxis
                                    dataKey="name"
                                    axisLine={false}
                                    tickLine={false}
                                    interval={0}
                                    padding={{ left: 20, right: 200 }}
                                    tick={({ x, y, payload }) => {
                                      return (
                                        <>
                                          <text
                                            x={x - 65} // move "Active" left to match bar
                                            y={y + 20}
                                            textAnchor="start"
                                            fontSize={14}
                                            fill="#5F6D8C"
                                          >
                                            Active
                                          </text>
                                          <text
                                            x={x + 25} // move "Utilized" right to match bar
                                            y={y + 20}
                                            textAnchor="start"
                                            fontSize={14}
                                            fill="#5F6D8C"
                                          >
                                            Utilized
                                          </text>
                                        </>
                                      );
                                    }}
                                  />
                                  <Tooltip />
                                  <Bar
                                    dataKey="Active"
                                    name="Active"
                                    fill="#9FE4FF"
                                    radius={[4, 4, 0, 0]}
                                    label={""}
                                  >
                                    <LabelList
                                      dataKey="Active"
                                      position="Middle"
                                    />
                                  </Bar>
                                  <Bar
                                    dataKey="Utilized"
                                    name="Utilized"
                                    fill="#7BFF88"
                                    radius={[4, 4, 0, 0]}
                                    label={BarCustomizedLabel}
                                  >
                                    <LabelList
                                      dataKey="Utilized"
                                      position="Middle"
                                    />
                                  </Bar>
                                  {vehicleUtilization.map((entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={COLORS[index % COLORS.length]}
                                      stroke={COLORS[index % COLORS.length]}
                                    />
                                  ))}
                                </BarChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            height: 325,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p style={{ color: "#999" }}>No Data Available</p>
                        </div>
                      )}
                    </Card>
                  </Col>
                  <Col
                    style={{ marginBottom: "5px" }}
                    lg={12}
                    md={24}
                    sm={24}
                    xs={24}
                    xl={12}
                  >
                    <div className="total">
                      <div className="head">
                        <p>{customTotal} Vehicles </p>
                      </div>
                      <div className="Custom">
                        <div>
                          <Spin spinning={CSVLoader}>
                            <img
                              src={upload}
                              alt="Upload Icon"
                              className="hover-image"
                              onClick={() => {
                                if (!exportAllowed) return;
                                prepareCSV();
                              }}
                              style={{
                                cursor: exportAllowed
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                            />
                          </Spin>
                          <CSVLink
                            data={CSVList}
                            filename={"Custom Dashboard.csv"}
                            asyncOnClick={true}
                            ref={csvLinkEl}
                          />
                        </div>
                        <div onClick={showModal}>
                          <Badge
                            count={filterCount}
                            className="badg"
                            offset={[0, 0]}
                          >
                            <Avatar
                              shape="circle"
                              size={46}
                              src={filtericon}
                              className="filterstyle"
                            />
                          </Badge>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <>
                  <div
                    // className="carddiv"
                    style={{
                      background:
                        window.innerWidth >= 769 && window.innerWidth <= 2561
                          ? ""
                          : "",
                      display:
                        windowWidth >= 427 && windowWidth <= 2561
                          ? "flex"
                          : "block",
                      gap:
                        windowWidth >= 427 && windowWidth <= 2561
                          ? "12px"
                          : "15px",
                    }}
                  >
                    <Card className="card-item" id="Trip_Status">
                      <div
                        //  id="Trip_Status"
                        className="title_new_column"
                      >
                        <p className="cardtitle">Trip Status</p>
                        <PrimaryExportIcon
                          style={{
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleDownloadChart("Trip_Status", "Trip_Status");
                          }}
                        />
                      </div>

                      {tripStatusChartLoading ? (
                        <p>Loading...</p>
                      ) : hasTripStatusData ? (
                        <div className="tripStatusChart">
                          <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                              <Pie
                                data={tripStatusChart}
                                cx="30%"
                                cy="50%"
                                innerRadius={68}
                                outerRadius={96}
                                paddingAngle={-15}
                                cornerRadius={40}
                                startAngle={330} // Starts at the top
                                endAngle={-250}
                                dataKey="value"
                                labelLine={false}
                                label={renderCustomizedLabel}
                              >
                                {tripStatusChart.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                    stroke={COLORS[index % COLORS.length]}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                      ) : (
                        <div
                          style={{
                            height: 250,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p style={{ color: "#999" }}>No Data Available</p>
                        </div>
                      )}
                    </Card>
                    <Card className="card-item">
                      <div className="title_new_column">
                        <p className="cardtitle">Vehicle Utilization</p>
                        <PrimaryExportIcon
                          style={{
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleDownloadChart(
                              "Vehicle_Utilization",
                              "Vehicle_Utilization",
                            );
                          }}
                        />
                      </div>

                      {vehicleUtilizationLoading ? (
                        <p>Loading...</p>
                      ) : hasVehicleUtilizationData ? (
                        // <ResponsiveContainer width="50%" height={300}>
                        //   <BarChart
                        //     data={vehicleUtilization}
                        //     margin={{
                        //       top: 40,
                        //       right: 30,
                        //       left: 20,
                        //       bottom: 5,
                        //     }}
                        //     barCategoryGap="25%"
                        //     barGap={55}
                        //     barSize={30}
                        //   >
                        //     <CartesianGrid stroke="none" />
                        //     <XAxis dataKey="name" axisLine={false} tickLine={false} />
                        //     {/* <YAxis axisLine={false} tickLine={false} /> */}
                        //     <Tooltip

                        //     />
                        //     <Bar
                        //       dataKey="Active"
                        //       name="Active"
                        //       fill="#9FE4FF"
                        //       radius={[5, 5, 0, 0]}
                        //       label={BarCustomizedLabel}
                        //     ></Bar>
                        //     <Bar
                        //       label={BarCustomizedLabel}
                        //       dataKey="Utilized"
                        //       name="Utilized"
                        //       fill="#7BFF88"
                        //       radius={[5, 5, 0, 0]}
                        //     />
                        //     {vehicleUtilization.map((entry, index) => (
                        //       <Cell
                        //         key={`cell-${index}`}
                        //         fill={COLORS[index % COLORS.length]}
                        //         stroke={COLORS[index % COLORS.length]}
                        //       />
                        //     ))}
                        //   </BarChart>
                        // </ResponsiveContainer>

                        <>
                          <div id="Vehicle_Utilization">
                            <ResponsiveContainer width="100%" height={300}>
                              <BarChart
                                data={vehicleUtilization}
                                margin={{
                                  top: 40,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                                }}
                                barCategoryGap="25%"
                                barGap={40}
                                barSize={52}
                              >
                                <CartesianGrid stroke="none" />
                                <XAxis
                                  dataKey="name"
                                  axisLine={false}
                                  tickLine={false}
                                  interval={0}
                                  padding={{ left: 20, right: 200 }}
                                  tick={({ x, y, payload }) => {
                                    return (
                                      <>
                                        <text
                                          x={x - 65} // move "Active" left to match bar
                                          y={y + 20}
                                          textAnchor="start"
                                          fontSize={14}
                                          fill="#5F6D8C"
                                        >
                                          Active
                                        </text>
                                        <text
                                          x={x + 25} // move "Utilized" right to match bar
                                          y={y + 20}
                                          textAnchor="start"
                                          fontSize={14}
                                          fill="#5F6D8C"
                                        >
                                          Utilized
                                        </text>
                                      </>
                                    );
                                  }}
                                />
                                <Tooltip />
                                <Bar
                                  dataKey="Active"
                                  name="Active"
                                  fill="#9FE4FF"
                                  radius={[4, 4, 0, 0]}
                                  label={""}
                                >
                                  <LabelList
                                    dataKey="Active"
                                    position="Middle"
                                  />
                                </Bar>
                                <Bar
                                  dataKey="Utilized"
                                  name="Utilized"
                                  fill="#7BFF88"
                                  radius={[4, 4, 0, 0]}
                                  label={BarCustomizedLabel}
                                >
                                  <LabelList
                                    dataKey="Utilized"
                                    position="Middle"
                                  />
                                </Bar>
                                {vehicleUtilization.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                    stroke={COLORS[index % COLORS.length]}
                                  />
                                ))}
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            height: 325,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p style={{ color: "#999" }}>No Data Available</p>
                        </div>
                      )}
                    </Card>
                  </div>

                  <br />
                  <div className="total">
                    <div className="head">
                      <p>{customTotal} Vehicles </p>
                    </div>
                    <div className="Custom">
                      <div>
                        <Spin spinning={CSVLoader}>
                          <img
                            src={upload}
                            alt="Upload Icon"
                            className="hover-image"
                            onClick={() => {
                              if (!exportAllowed) return;
                              prepareCSV();
                            }}
                            style={{
                              cursor: exportAllowed ? "pointer" : "not-allowed",
                            }}
                          />
                        </Spin>
                        <CSVLink
                          data={CSVList}
                          filename={"Custom Dashboard.csv"}
                          asyncOnClick={true}
                          ref={csvLinkEl}
                        />
                      </div>
                      <div onClick={showModal}>
                        <Badge
                          count={filterCount}
                          className="badg"
                          offset={[0, 0]}
                        >
                          <Avatar
                            shape="circle"
                            size={46}
                            src={filtericon}
                            className="filterstyle"
                          />
                        </Badge>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <br />
              <StyledTable
                dataSource={Customdata}
                columns={CustomColumn}
                pagination={false}
              />
              <ReusablePagination
                pageSize={customPageSize}
                handlePageSizeChange={handleCustomPageSizeChange}
                currentPage={customCurrentPage}
                total={customTotal}
                handlePageChange={handleCustomPageChange}
              />

              <Modal
                open={isModalOpen}
                onCancel={handleCancel}
                width={800}
                footer={
                  <Button
                    onClick={() => {
                      form.resetFields();
                      setFormValues({});
                      setFilterCount(0);
                    }}
                  >
                    Clear All
                  </Button>
                }
              >
                <Row>
                  <Col span={24}>
                    <div className="container_for_kpi_filter">
                      <h6 className="Filter_for_clickablerow">
                        Filter ({filterCount})
                      </h6>
                    </div>
                  </Col>
                </Row>

                <Form
                  form={form}
                  layout="vertical"
                  onValuesChange={(changed, all) => {
                    setFormValues(all);
                    getFilterCount();
                  }}
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item label="Vehicle" name="vehicle">
                        <Select
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          options={vehicleListone?.map((item) => ({
                            label: item.REGNO,
                            value: item.VEHID,
                          }))}
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </Col>
                    {/* 
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col> */}
                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Date" name="daterange">
                        <DatePicker />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        label="Trip Type
              "
                        name="tripType"
                      >
                        <Select showSearch allowClear>
                          <Option value={2}>Safari</Option>
                          <Option value={1}>Local</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={6}>
                      <Form.Item label="Status" name="Status">
                        <Select
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          options={TripStatusForCustom?.map((item) => ({
                            label: item.label,
                            value: item.value,
                          }))}
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </Customstyle>
          )}
        </div>
      </Customstyle>
    </>
  );
};

export const TrackrightAI = ({ exportAllowed }) => {
  const csvLinkEl = useRef();
  // const COLORS = ["#00BC13", "#007EEA"];
  // const COLORS = ["#007EEA", "#00BC13"];
  const COLORS = ["#007EEA", "#00BC13"]; // Blue, Green
  const barcolor = ["#9FE4FF", "#7BFF88"];
  const [tripStatus, setTripStatus] = useState([]);
  const [tripStatusLoading, setTripStatusLoading] = useState(false);
  const [tripStatusChart, setTripStatusChart] = useState([]);
  const [vehicleUtilization, setVehicleUtilization] = useState([]);
  const [tripStatusChartLoading, setTripStatusChartLoading] = useState(false);
  const [vehicleUtilizationLoading, setVehicleUtilizationLoading] =
    useState(false);
  const [Customdata, setCustomdata] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const [tableLoading, setTableLoading] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );

  //FILTER
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({});

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  const getFilterCount = () => {
    const values = form.getFieldsValue();
    const count = Object.values(values).filter(
      (val) => val !== undefined && val !== null && val !== "",
    ).length;
    setFilterCount(count);
  };

  //Pagination
  const [customPageSize, setCustomPageSize] = useState(10);
  const [customCurrentPage, setCustomCurrentPage] = useState(1);
  const [customTotal, setCustomTotal] = useState(0);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);

  
  const [expandedIndexes, setExpandedIndexes] = useState({});
  const toggleExpand = (key) => {
    setExpandedIndexes((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleCustomPageChange = (page, pageSize) => {
    setCustomCurrentPage(page);
    setCustomPageSize(pageSize);
    getCustomTableData(page, pageSize);
  };

  const handleCustomPageSizeChange = (size) => {
    setCustomPageSize(size);
    setCustomCurrentPage(1);
    getCustomTableData(1, size);
  };

  const getTripStatus = async () => {
    try {
      setTripStatusLoading(true);
      const { data } = await CALL_API("POST", "customeDashboard");
      setTripStatus(data);
      setTripStatusLoading(false);
    } catch (error) {
      console.error("[getTripStatus] error -->", error);
    }
  };

  useEffect(() => {
    getTripStatus();
  }, []);

  const BarCustomizedLabel = ({ x, y, width, height, value, index }) => {
    const labelX = x + width / 2;
    const labelY = y - 10; // Put label above the bar
    const lineMidX = labelX + 80; // Shorter horizontal connector
    const lineEndX = lineMidX + 40;
    const lineEndY = labelY - 40;
    const utilizedPercent = vehicleUtilization[0]
      ? Math.round(
          (vehicleUtilization[0].Utilized / vehicleUtilization[0].Active) * 100,
        )
      : 0;
    return (
      <>
        {/* Horizontal line from the bar to the mid point */}
        <line
          x1={labelX}
          y1={labelY + 10}
          x2={lineMidX}
          y2={labelY + 10}
          stroke="#aaa"
          strokeWidth={1.5}
        />

        {/* Diagonal line from the mid point to the box */}
        <line
          x1={lineMidX}
          y1={labelY + 10}
          x2={lineEndX}
          y2={lineEndY}
          stroke="#aaa"
          strokeWidth={1.5}
        />

        {/* Green box (legend color block) */}
        <rect
          x={lineEndX - 35}
          y={lineEndY - 25}
          width={16}
          height={16}
          rx={3}
          fill="#7BFF88"
        />

        <text x={lineEndX - 10} y={lineEndY - 12} fontSize={16} fill="#5F6D8C">
          Utilized {utilizedPercent}%
        </text>
      </>
    );
  };
  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    name,
    index,
  }) => {
    const isSmallSlice = percent < 0.1; // catches small slices like 4/99

    // Push small slices further out to avoid overlap
    const anchorRadius = outerRadius + (isSmallSlice ? 30 : 8);

    const sx = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const sy = cy + outerRadius * Math.sin(-midAngle * RADIAN);

    const mx = cx + anchorRadius * Math.cos(-midAngle * RADIAN);
    const my = cy + anchorRadius * Math.sin(-midAngle * RADIAN);

    const isRightSide = Math.cos(-midAngle * RADIAN) >= 0;
    const lineLength = 30;

    const ex = mx + (isRightSide ? lineLength : -lineLength);
    const ey = my;

    const textAnchor = isRightSide ? "start" : "end";
    const color = COLORS[index % COLORS.length];
    const value = tripStatusChart[index]?.value || 0;

    return (
      <g>
        <path
          d={`M${sx},${sy} L${mx},${my} L${ex},${ey}`}
          fill="none"
          stroke="#C0C6D4"
          strokeWidth={1.2}
        />
        <rect
          x={isRightSide ? ex + 4 : ex - 18}
          y={ey - 6}
          width={10}
          height={10}
          fill={color}
        />
        <text
          x={isRightSide ? ex + 18 : ex - 20}
          y={ey}
          textAnchor={textAnchor}
          dominantBaseline="middle"
          fill="#5F6D8C"
          fontSize={12}
        >
          {`${name} (${value})`}
        </text>
      </g>
    );
  };
  const getTripStatusChart = async (loadingKey) => {
    try {
      if (loadingKey === "initialLoading") {
        setTripStatusChartLoading(true);
      }
      const res = await CALL_API("GET", "ai/custom/trip_status");
      const result = res?.data || {};
      let chartData = [
        { name: "Trips in Progress", value: result.inProgress || 0 }, // Blue
        { name: "Trips Delivered", value: result.delivered || 0 }, // Green
      ];
      chartData = chartData.filter((item) => item.value > 0);

      if(JSON.stringify(tripStatusChart) !== JSON.stringify(chartData)){
        setTripStatusChart(chartData);
      }
    } catch (error) {
      console.error("Error fetching trip status", error);
    } finally {
      setTripStatusChartLoading(false);
    }
  };

  const getVehicleUtilization = async (loadingKey) => {
    try {
      if (loadingKey === "initialLoading") {
        setVehicleUtilizationLoading(true);
      }
      const res = await CALL_API(
        "GET",
        `ai/custom/vehicle_utilized?mcid=${userInfo?.MCID}`,
      );
      const result = res?.data || {};
      const chartData = [
        {
          name: "Active   Utilized",
          Active: result.activeVehicles || 0,
          Utilized: result.usedVehicles || 0,
        },
      ];

      if(JSON.stringify(vehicleUtilization) !== JSON.stringify(chartData)){
        setVehicleUtilization(chartData);
      }
    } catch (error) {
      console.error("Error fetching vehicle utilization", error);
    } finally {
      setVehicleUtilizationLoading(false);
    }
  };
  const getCustomTableData = async (
    page = customCurrentPage,
    perPage = customPageSize,
  ) => {
    setTableLoading(true);
    try {
      const tripTypeString = TripTypeEnum.find(
        (item) => item.value === formValues?.tripType,
      )?.name;

      const payload = {
        Duration: "Desc",
        Date: formValues?.daterange
          ? dayjs(formValues?.daterange).format("YYYY-MM-DD")
          : "",
        RECNAME: userInfo?.consigneeList,
        Routes: "",
        Invoice: "",
        Package: "",
        TRIPTYPE: tripTypeString,
        VEHID: formValues?.vehicle || 0,
        CUSTCOLS: "",
        Status: formValues?.Status || null,
        mcId: userInfo?.MCID,
        PerPage: perPage,
        CurPage: page,
      };

      const { data } = await CALL_API(
        "POST",
        "ai/custom/getAllCustomDashData",
        payload,
      );
      setCustomdata(data?.data || []);
      setCustomTotal(data?.total || 0); // If backend returns total
    } catch (error) {
      console.error("[getCustomTableData] error -->", error);
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    getCustomTableData();
  }, [formValues?.daterange]);

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const tripTypeString = TripTypeEnum.find(
        (item) => item.value === formValues?.tripType,
      )?.name;

      const payload = {
        Duration: "Desc",
        Date: formValues?.daterange
          ? dayjs(formValues?.daterange).format("YYYY-MM-DD")
          : "",
        RECNAME: userInfo?.consigneeList,
        Routes: "",
        Invoice: "",
        Package: "",
        TRIPTYPE: tripTypeString,
        VEHID: formValues?.vehicle || 0,
        CUSTCOLS: "",
        mcId: userInfo?.MCID || 0,
        PerPage: customTotal,
        CurPage: 1,
      };

      const { data } = await CALL_API(
        "POST",
        "ai/custom/getAllCustomDashData",
        payload,
      );
      setCSVLoader(false);
      if (data?.data?.length > 0) {
        setCSVList(
          data?.data?.map((item) => {
            const tripStatusLabel = TripStatusMap[item.TRIPSTATUS] || "Unknown";

            return {
              Vehicle: item.REGNO || "-",
              "Trip Type": item.TRIPTYPE || "-",
              Status: tripStatusLabel,
              Consignment: item.Consignments || "-",
              "Delivered / Ordered": `${item.Delivered || 0} / ${
                item.Ordered || 0
              }`,
              "Offloaded Consignments (Day)": item.TotalConsignment_DAY || 0,
              "Offloaded Consignments (Month)":
                item.TotalConsignment_MONTH || 0,
              "Total KMs (Month)": item.TotalKM ?? 0,
            };
          }),
        );

        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  useEffect(() => {
    getTripStatusChart("initialLoading");
    getVehicleUtilization("initialLoading");

    const interval = setInterval(() => {
      getTripStatusChart();
      getVehicleUtilization();
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    // getTripStatusChart();
    // getVehicleUtilization();
    getCustomTableData(customCurrentPage, customPageSize);
  }, [formValues, selectedDate, customCurrentPage, customPageSize]);

  const hasTripStatusData = tripStatusChart?.some((item) => item.value > 0);
  const hasVehicleUtilizationData = vehicleUtilization?.some(
    (item) => item.Active > 0 || item.Utilized > 0,
  );
  const TripStatusMap = TripStatusEnum.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
  }, {});

  const CustomColumn = [
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      render: (text, record) => {
        const statusLabel = TripStatusMap[record.TRIPSTATUS];
        return (
          <div>
            <span>{text}</span>
            {statusLabel === "Completed" ? (
              <div
                style={{
                  color: "#E4A400",
                  fontWeight: "400",
                  marginTop: "4px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span className="ab"></span>
                Safari
              </div>
            ) : statusLabel === "In Progress" ? (
              <div>
                <i> Local</i>
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "Color",
      key: "Color",
      render: (value, record) => {
        let label = "Unknown";
        let statusClass = "unknown";

        // Map Color values to labels and styles
        if (value === 1) {
          label = "Completed";
          statusClass = "completed";
        } else if (value === 2) {
          label = "In Progress";
          statusClass = "in-progress";
        } else if (value === 0) {
          label = "Unassigned";
          statusClass = "unassigned";
        }

        return (
          <div className="status-container">
            <span className={`status-circle ${statusClass}`}></span>
            {label}
          </div>
        );
      },
    },
    {
      title: "Consignment",
      dataIndex: "Consignments",
      key: "Consignments",
      render: (text, record, index) => {  // ← add index parameter here
        const input = "Nakuru Customer0 , Nakuru Customer0 , Nakuru Customer0";
        const extractnamestoarray = text
          .split(",")
          .map((item) => item.trim().slice(0, -1))
          .filter((item) => item.trim() !== "");

        const getColor = (value) => {
          const lastChar = text.slice(-1);
          return lastChar === "1" ? "text-success" : "";
        };

        // Use index as unique key — guaranteed unique per row in the table
        const rowKey = index;

        return (
          <div>
            {/* Always show first item */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <p className={getColor(extractnamestoarray[0])} style={{ margin: 0 }}>
                {extractnamestoarray[0]}
              </p>

              {/* Arrow only if more than 1 item */}
              {extractnamestoarray.length > 1 && (
                <DownOutlined
                  onClick={() => toggleExpand(rowKey)}
                  style={{
                    color: "#2C963D", marginLeft: "8px",
                    cursor: "pointer",
                    fontSize: "11px",
                    transform: expandedIndexes[rowKey] ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
              )}
            </div>

            {/* Remaining items when expanded */}
            {expandedIndexes[rowKey] &&
              extractnamestoarray.slice(1).map((item, subIndex) => (
                <p className={getColor(item)} key={subIndex} style={{ margin: 0 }}>
                  {item}
                </p>
              ))}
          </div>
        );
      },
    },
    {
      title: "Delivered / Ordered",
      key: "DeliveredOrdered",
      align: "center",
      render: (text, record) => (
        <span>
          {record.Delivered ?? 0}/{record.Ordered ?? 0}
        </span>
      ),
    },
    {
      title: (
        <>
          <div>Offloaded Consignments</div>
          <div className="titlestyle">(Day)</div>
        </>
      ),
      dataIndex: "TotalConsignment_DAY",
      key: "TotalConsignment_DAY",
      align: "center",
      render: (text) => text ?? 0,
    },
    {
      title: (
        <>
          <div>Offloaded Consignments</div>
          <div className="titlestyle">(Month)</div>
        </>
      ),
      dataIndex: "TotalConsignment_MONTH",
      key: "TotalConsignment_MONTH",
      align: "center",
      render: (text) => text ?? 0,
    },
    {
      title: (
        <>
          <div>Total Kms </div>
          <div className="titlestyle">(Month)</div>
        </>
      ),
      dataIndex: "TotalKM",
      key: "TotalKM",
      align: "center",
      render: (text) => text ?? 0,
    },
  ];
  const Customdata1 = [
    {
      key: "1",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "2",
      Vehicle: "KA1234532",
      Status: "In Progress",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "3",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "4",
      Vehicle: "KA1234532",
      Status: "In Progress",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/5",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
    {
      key: "5",
      Vehicle: "KA1234532",
      Status: "Completed",
      Consignment: "Pawni Oil Mombasa",
      DeliveredOrdered: "1/1",
      Offloadedday: "1",
      Offloadedmonths: "10",
      TotalKms: "35",
    },
  ];
  return (
    <>
      <Customstyle>
        <div className="Wrapper_div">
          <p className="Wrappertitle">Chart View</p>
          {/* <Card className="Card_for_containerone">
          <div className="title_new_column">
            <p className="title_onE">Chart View</p>
            <PrimaryExportIcon   
             onClick={()=> {
               handleDownloadChart("Export Chart" , "Trip Status" )
                  handleDownloadChart("Export Chart vehicleutilization", "Vehicle Utilization");
   }}/>
          </div>
        </Card> */}
          <br />

          {window.innerWidth >= 320 && window.innerWidth <= 425 ? (
            <>
              <Row>
                <Col className="mb-2" md={24} sm={24} xs={24}>
                  <Card className="card-item">
                    <p className="cardtitle">Trip Status</p>
                    {tripStatusChartLoading ? (
                      <p>Loading...</p>
                    ) : hasTripStatusData ? (
                      <div style={{ overflowX: "auto", width: "100%" }}>
                        <div style={{ minWidth: 600 }}>
                          <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                              <Pie
                                data={tripStatusChart}
                                cx="50%"
                                cy="50%"
                                innerRadius={68}
                                outerRadius={96}
                                paddingAngle={-15}
                                cornerRadius={40}
                                startAngle={330} // Starts at the top
                                endAngle={-250}
                                dataKey="value"
                                labelLine={false}
                                label={renderCustomizedLabel}
                              >
                                {tripStatusChart.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                    stroke={COLORS[index % COLORS.length]}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          height: 250,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p style={{ color: "#999" }}>No Data Available</p>
                      </div>
                    )}
                  </Card>
                </Col>
                <Col className="mb-2" md={24} sm={24} xs={24}>
                  <Card className="card-item">
                    <p className="cardtitle">Vehicle Utilization</p>
                    {vehicleUtilizationLoading ? (
                      <p>Loading...</p>
                    ) : hasVehicleUtilizationData ? (
                      <>
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <div style={{ minWidth: 600 }}>
                            <ResponsiveContainer width="100%" height={300}>
                              <BarChart
                                data={vehicleUtilization}
                                margin={{
                                  top: 40,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                                }}
                                barCategoryGap="25%"
                                barGap={40}
                                barSize={52}
                              >
                                <CartesianGrid stroke="none" />
                                <XAxis
                                  dataKey="name"
                                  axisLine={false}
                                  tickLine={false}
                                  interval={0}
                                  padding={{ left: 20, right: 200 }}
                                  tick={({ x, y, payload }) => {
                                    return (
                                      <>
                                        <text
                                          x={x - 65} // move "Active" left to match bar
                                          y={y + 20}
                                          textAnchor="start"
                                          fontSize={14}
                                          fill="#5F6D8C"
                                        >
                                          Active
                                        </text>
                                        <text
                                          x={x + 25} // move "Utilized" right to match bar
                                          y={y + 20}
                                          textAnchor="start"
                                          fontSize={14}
                                          fill="#5F6D8C"
                                        >
                                          Utilized
                                        </text>
                                      </>
                                    );
                                  }}
                                />
                                <Tooltip />
                                <Bar
                                  dataKey="Active"
                                  name="Active"
                                  fill="#9FE4FF"
                                  radius={[4, 4, 0, 0]}
                                  label={""}
                                >
                                  <LabelList
                                    dataKey="Active"
                                    position="Middle"
                                  />
                                </Bar>
                                <Bar
                                  dataKey="Utilized"
                                  name="Utilized"
                                  fill="#7BFF88"
                                  radius={[4, 4, 0, 0]}
                                  label={BarCustomizedLabel}
                                >
                                  <LabelList
                                    dataKey="Utilized"
                                    position="Middle"
                                  />
                                </Bar>
                                {vehicleUtilization.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                    stroke={COLORS[index % COLORS.length]}
                                  />
                                ))}
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          height: 325,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p style={{ color: "#999" }}>No Data Available</p>
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <div
                style={
                  window.innerWidth >= 769 && window.innerWidth <= 2561
                    ? { display: "flex", gap: "20px" }
                    : { display: "block" }
                }
              >
                <Card className="card-item" id="Trip_Status_AI">
                  <div className="title_new_column">
                    <p className="cardtitle">Trip Status</p>
                    <PrimaryExportIcon
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Trip_Status_AI", "Trip_Status");
                      }}
                    />
                  </div>

                  {tripStatusChartLoading ? (
                    <p>Loading...</p>
                  ) : hasTripStatusData ? (
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={tripStatusChart}
                          cx="50%"
                          cy="50%"
                          innerRadius={68}
                          outerRadius={96}
                          paddingAngle={-15}
                          cornerRadius={40}
                          startAngle={330} // Starts at the top
                          endAngle={-250}
                          dataKey="value"
                          labelLine={false}
                          label={renderCustomizedLabel}
                        >
                          {tripStatusChart.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                              stroke={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  ) : (
                    <div
                      style={{
                        height: 250,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <p style={{ color: "#999" }}>No Data Available</p>
                    </div>
                  )}
                </Card>
                <Card className="card-item">
                  <div className="title_new_column">
                    <p className="cardtitle">Vehicle Utilization</p>
                    <PrimaryExportIcon
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Vehicle_Utilizationtwo",
                          "Vehicle_Utilizationtwo",
                        );
                      }}
                    />
                  </div>

                  {vehicleUtilizationLoading ? (
                    <p>Loading...</p>
                  ) : hasVehicleUtilizationData ? (
                    // <ResponsiveContainer width="50%" height={300}>
                    //   <BarChart
                    //     data={vehicleUtilization}
                    //     margin={{
                    //       top: 40,
                    //       right: 30,
                    //       left: 20,
                    //       bottom: 5,
                    //     }}
                    //     barCategoryGap="25%"
                    //     barGap={55}
                    //     barSize={30}
                    //   >
                    //     <CartesianGrid stroke="none" />
                    //     <XAxis dataKey="name" axisLine={false} tickLine={false} />
                    //     {/* <YAxis axisLine={false} tickLine={false} /> */}
                    //     <Tooltip

                    //     />
                    //     <Bar
                    //       dataKey="Active"
                    //       name="Active"
                    //       fill="#9FE4FF"
                    //       radius={[5, 5, 0, 0]}
                    //       label={BarCustomizedLabel}
                    //     ></Bar>
                    //     <Bar
                    //       label={BarCustomizedLabel}
                    //       dataKey="Utilized"
                    //       name="Utilized"
                    //       fill="#7BFF88"
                    //       radius={[5, 5, 0, 0]}
                    //     />
                    //     {vehicleUtilization.map((entry, index) => (
                    //       <Cell
                    //         key={`cell-${index}`}
                    //         fill={COLORS[index % COLORS.length]}
                    //         stroke={COLORS[index % COLORS.length]}
                    //       />
                    //     ))}
                    //   </BarChart>
                    // </ResponsiveContainer>
                    <>
                      <div
                        id="Vehicle_Utilizationtwo"
                        style={{ overflowX: "auto", width: "100%" }}
                      >
                        <div style={{ minWidth: 600 }}>
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                              data={vehicleUtilization}
                              margin={{
                                top: 40,
                                right: 30,
                                left: 20,
                                bottom: 5,
                              }}
                              barCategoryGap="25%"
                              barGap={40}
                              barSize={52}
                            >
                              <CartesianGrid stroke="none" />
                              <XAxis
                                dataKey="name"
                                axisLine={false}
                                tickLine={false}
                                interval={0}
                                padding={{ left: 20, right: 200 }}
                                tick={({ x, y, payload }) => {
                                  return (
                                    <>
                                      <text
                                        x={x - 65} // move "Active" left to match bar
                                        y={y + 20}
                                        textAnchor="start"
                                        fontSize={14}
                                        fill="#5F6D8C"
                                      >
                                        Active
                                      </text>
                                      <text
                                        x={x + 25} // move "Utilized" right to match bar
                                        y={y + 20}
                                        textAnchor="start"
                                        fontSize={14}
                                        fill="#5F6D8C"
                                      >
                                        Utilized
                                      </text>
                                    </>
                                  );
                                }}
                              />
                              <Tooltip />
                              <Bar
                                dataKey="Active"
                                name="Active"
                                fill="#9FE4FF"
                                radius={[4, 4, 0, 0]}
                                label={""}
                              >
                                <LabelList dataKey="Active" position="Middle" />
                              </Bar>
                              <Bar
                                dataKey="Utilized"
                                name="Utilized"
                                fill="#7BFF88"
                                radius={[4, 4, 0, 0]}
                                label={BarCustomizedLabel}
                              >
                                <LabelList
                                  dataKey="Utilized"
                                  position="Middle"
                                />
                              </Bar>
                              {vehicleUtilization.map((entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={COLORS[index % COLORS.length]}
                                  stroke={COLORS[index % COLORS.length]}
                                />
                              ))}
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        height: 325,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <p style={{ color: "#999" }}>No Data Available</p>
                    </div>
                  )}
                </Card>
              </div>
            </>
          )}

          <br />
          <div className="total">
            <div className="head">
              <p>{customTotal} Vehicles </p>
            </div>
            <div className="Custom">
              <div>
                <Spin spinning={CSVLoader}>
                  <img
                    src={upload}
                    alt="Upload Icon"
                    className="hover-image"
                    onClick={() => {
                      if (!exportAllowed) return;
                      prepareCSV();
                    }}
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                  />
                </Spin>
                <CSVLink
                  data={CSVList}
                  filename={"Custom Dashboard.csv"}
                  asyncOnClick={true}
                  ref={csvLinkEl}
                />
              </div>
              <div onClick={showModal}>
                <Badge count={filterCount} className="badg" offset={[0, 0]}>
                  <Avatar
                    shape="circle"
                    size={46}
                    src={filtericon}
                    className="filterstyle"
                  />
                </Badge>
              </div>
            </div>
          </div>
          <br />
          <StyledTable
            dataSource={Customdata}
            columns={CustomColumn}
            pagination={false}
          />
          <ReusablePagination
            pageSize={customPageSize}
            handlePageSizeChange={handleCustomPageSizeChange}
            currentPage={customCurrentPage}
            total={customTotal}
            handlePageChange={handleCustomPageChange}
          />

          <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            width={800}
            footer={
              <Button
                onClick={() => {
                  form.resetFields();
                  setFormValues({});
                  setCustomCurrentPage(1);
                  setFilterCount(0);
                }}
              >
                Clear All
              </Button>
            }
          >
            <Row>
              <Col span={24}>
                <div className="container_for_kpi_filter">
                  <h6 className="Filter_for_clickablerow">
                    Filter ({filterCount})
                  </h6>
                </div>
              </Col>
            </Row>

            <Form
              form={form}
              layout="vertical"
              onValuesChange={(changed, all) => {
                setCustomCurrentPage(1);
                setFormValues(all);
                getFilterCount();
              }}
            >
              <Row gutter={16}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="Vehicle" name="vehicle">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      options={AIVehicleLists?.map((item) => ({
                        value: item?.FGUID,
                        label: item?.FVehicleName,
                      }))}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                {/* 
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col> */}
                <Col xs={24} sm={24} md={6}>
                  <Form.Item label="Date" name="daterange">
                    <DatePicker />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="Trip Type
              "
                    name="tripType"
                  >
                    <Select showSearch allowClear>
                      <Option value={2}>Safari</Option>
                      <Option value={1}>Local</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="Status" name="Status">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      options={TripStatusForCustom?.map((item) => ({
                        label: item.label,
                        value: item.value,
                      }))}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        </div>
      </Customstyle>
    </>
  );
};

export default CustomDashboardAI;
